// AI-CONTEXT: See docs/features/participatieladder-2026-3.md
import { useState } from 'react'
import { useFirestoreQuery } from '../firebase/useFirestore'
import birthDatesByPersona, { BIRTH_DATE_TITLE } from '../helpers/participationHelpers/birthDatesByPersona'

const NOT_NEEDED = {}

/**
 * De geboortedatums van alle deelnemers van deze organisatie (één query op
 * `PersonaData` met Title 'Geboortedatum'), voor de leeftijdsovergang van
 * parameterset 2026.3 bij een totaal over meerdere deelnemers.
 *
 * Nodig het rekenmodel ze niet (2026.1/2026.2), dan geen listener en een leeg
 * object. Anders `null` zolang de read loopt, zodat een totaal niet even
 * zonder leeftijdsregel verschijnt.
 * AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading
 *
 * @param {boolean} needed - Rekent de vastgezette parameterset met de leeftijdsovergang?
 * @returns {{ birthDates: Object<string, string>|null, error: Error|null }}
 */
const useParticipationBirthDates = (needed) => {
    const [error, setError] = useState(/** @type {Error|null} */ (null))
    const rows = useFirestoreQuery('PersonaData', {
        where: [['Title', '==', BIRTH_DATE_TITLE]],
        enabled: needed,
        onError: setError,
    })
    if (!needed) return { birthDates: NOT_NEEDED, error: null }
    return { birthDates: birthDatesByPersona(rows), error }
}

export default useParticipationBirthDates
